var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { AppContext } from '../appContext';
var CloseWidgetPanel = function () {
    var parentContext = useContext(AppContext);
    var chatBubbleClicked = parentContext.chatBubbleClicked;
    return (_jsx("div", __assign({ className: "closeChatWidgetPanel", onClick: chatBubbleClicked }, { children: _jsx("svg", __assign({ focusable: "false", "aria-hidden": "true", width: "12", height: "12", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "white" }, { children: _jsx("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8 7.23251L7.23251 8L4 4.76749L0.767492 8L0 7.23251L3.23251 4L0 0.767492L0.767492 0L4 3.23251L7.23251 0L8 0.767492L4.76749 4L8 7.23251Z", fill: "currentColor" }) })) })));
};
export default CloseWidgetPanel;
